import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';


import { BnNgIdleService } from 'bn-ng-idle';

import { environment } from '../environments/environment';
import { SeguridadUsuarioEncritacion } from './core/models/general/seguridad-usuario-encriptacion';
import { TranslateService } from '@ngx-translate/core';
const limiteTiempoSession = environment.limiteSessionExpirada;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'SIU';
  validarLogin: any;
  validarUsuarioInicio: string = '';
  columns!: string;
  seguridadUsuarioEncritacion!: SeguridadUsuarioEncritacion;
  constructor(public router: Router, private bnIdle: BnNgIdleService,
    public dialog: MatDialog,
    public traslate: TranslateService
  ) {

    this.bnIdle.startWatching(limiteTiempoSession).subscribe((res) => {
      if (res === true && localStorage.getItem('isLoggedin') === 'true') {
        this.router.navigate(['/session']);
      }
    });
    this.onToggleMenuSidebar();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if ((window as any).AdminLTE && (window as any).AdminLTE.PushMenu) {
        new (window as any).AdminLTE.PushMenu('[data-widget="pushmenu"]');

        // Verificar si el usuario ya cerró el menú antes
        if (localStorage.getItem('menuCollapsed') === 'true') {
          document.body.classList.add('sidebar-collapse');
        }
      }
    }, 500);
  }

  onToggleMenuSidebar() {
    document.body.classList.toggle('sidebar-collapse');

    // Guardar el estado en localStorage
    if (document.body.classList.contains('sidebar-collapse')) {
      localStorage.setItem('menuCollapsed', 'true');
    } else {
      localStorage.setItem('menuCollapsed', 'false');
    }
  }


  ngOnInit() {
    this.seguridadUsuarioEncritacion = new SeguridadUsuarioEncritacion();
    this.validarLogin = localStorage.getItem('isLoggedin');

    if (this.validarLogin === 'true' && this.seguridadUsuarioEncritacion.desencriptarUsuario() !== null
      && this.seguridadUsuarioEncritacion.desencriptarUsuario().username !== undefined) {

      this.validarUsuarioInicio = this.seguridadUsuarioEncritacion.desencriptarUsuario().username;
      if (this.validarUsuarioInicio != null) {
        if (this.validarUsuarioInicio.length <= 2) {
          this.router.navigate(['/login']);
        }
      }
    } else {
      if (window.location.href.includes('publico')) {
        var enrutamiento = window.location.href;
        enrutamiento = enrutamiento.replace(environment.apiUrlAlpha, '');
        this.router.navigate([enrutamiento]);

      } else if (window.location.href.includes('qr')) {
        var enrutamiento = window.location.href;
        enrutamiento = enrutamiento.replace(environment.apiUrlAlpha, '');
        this.router.navigate([enrutamiento]);

      } else if (window.location.href.includes('manager')) {
        var enrutamiento = window.location.href;
        enrutamiento = enrutamiento.replace(environment.apiUrlAlpha, '');
        this.router.navigate([enrutamiento]);

      } else {
        localStorage.clear();
        this.router.navigate(['/login']);
      }
    }
  }

}
